<script setup lang="ts">
import type { ComponentStyles } from 'types/index';

const layout = useLayout();

defineProps<{
  data: TextWithGraphicData;
  componentStyles: ComponentStyles;
}>();
</script>

<template>
  <BaseComponentWrapper
    v-if="data"
    :component-styles="componentStyles"
  >
    <article class="container grid grid-cols-1 gap-y-8 lg:grid-cols-2 lg:gap-24">
      <div
        class="flex w-full flex-col justify-center"
        :class="{ 'order-last': data.reverse && layout.isDesktop }"
      >
        <BaseRte
          v-if="data.text"
          :content="data.text"
        />

        <BaseButton
          v-if="data.cta"
          class="mt-6 md:mt-12"
          :to="data.cta.url"
          :title="data.cta.name"
          :target="data.cta.target"
        >
          {{ data.cta.name }}
        </BaseButton>
      </div>

      <div class="flex max-h-[800px] w-full items-center overflow-hidden">
        <HumbleScroll
          animation="fade"
          class="size-full"
          inner-class="size-full"
        >
          <figure
            v-if="data.image?.url"
            class="flex size-full items-center"
          >
            <BaseImage
              :image="data.image"
              :aspect-ratio="data.mediaAspect"
              class="size-full object-contain"
            />
          </figure>
        </HumbleScroll>
      </div>
    </article>
  </BaseComponentWrapper>
</template>
